import React, { memo } from 'react';
import styles from './NavSecond.module.css';
import balonA from "../../assets/balonBtn.png"
import balonB from "../../assets/BalonBtnB.png"
import userA from "../../assets/UserBtnA.png"
import userB from "../../assets/UserBtn.png"

const NavSecond = memo(({ 
  handleDisplayShow,
  displayShow,
  user, 
  isVisitor 
}) => {
  const handleNavigation = (section) => {
    const actions = {
      metrics: () => {
        window.scrollTo(0, 0);
        document.body.classList.remove('socialActive');
        if (isVisitor) {
          handleDisplayShow('PERFIL');
        } else {
          handleDisplayShow('MÉTRICAS');
        }
      },
      social: () => {
        document.body.classList.add('socialActive');
        window.scrollTo(0, 0);
        handleDisplayShow('SOCIAL');
      },
      recruitment: () => {
        document.body.classList.remove('socialActive');
        window.scrollTo(0, 0);
        handleDisplayShow('RECLUTAMIENTO');
      }
    };
    
    actions[section]?.();
  };

  const renderButton = (type, isActive, onClick, text) => (
    <div className={styles.btn} onClick={onClick}>
      <img 
        className={styles.icon} 
        src={type === 'metrics' ? (isActive ? balonA : balonB) : (isActive ? userA : userB)} 
        alt={text}
      />
      <p className={isActive ? styles.txtBtnSelect : styles.txtBtn}>{text}</p>
    </div>
  );

  // Determinar qué botón está activo basado en displayShow
  const isMetricsActive = isVisitor ? displayShow === 'PERFIL' : displayShow === 'MÉTRICAS';
  const isSocialActive = displayShow === 'SOCIAL';
  const isRecruitmentActive = displayShow === 'RECLUTAMIENTO';

  return (
    <div className={styles.navSecond}>
      <div className={styles.botones}>
        {isVisitor ? (
          <>
            {renderButton('metrics', isMetricsActive, () => handleNavigation('metrics'), 'PERFIL')}
            {renderButton('social', isSocialActive, () => handleNavigation('social'), 'SOCIAL')}
          </>
        ) : (
          <>
            {renderButton('metrics', isMetricsActive, () => handleNavigation('metrics'), 'MÉTRICAS')}
            {user?.rol !== "Jugador" && 
              renderButton('social', isRecruitmentActive, () => handleNavigation('recruitment'), 'RECLUTAMIENTO')
            }
            {renderButton('social', isSocialActive, () => handleNavigation('social'), 'SOCIAL')}
          </>
        )}
      </div>
    </div>
  );
});

NavSecond.displayName = 'NavSecond';

export default NavSecond;